import React ,{useRef ,useEffect}from 'react';
import './shop.scss'
import IrtizaDynamicInputList from '../dynamic-input/dynamic-input-list';
import IrtizaDynamicInputAddNewList from '../dynamic-input/dynamic-input-add-new-list';
import moment from 'moment'
import SecurityService from '../security/security.service';
import ShopService from './shop.service';
import ShopAdd from './shop-add';
import AuditTableInput from '../audit-table/audit-table'


const ShopInput = (props) => {

// ShopID	
// ShopName	
// LocalCurrencyOpening	
// SerialNo
    let columns =[
        {  field: "ShopID",headerText:'ID',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "ShopName",headerText:'Shop Name',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "LocalCurrencyOpening",headerText:'Local Currency Opening',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{format:'n0'}]},
        {  field: "SerialNo",headerText:'Serial No',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{format:'n0'}]},
      ]

       const listActionComplete = (grid,args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
          if (args.requestType == 'save' || args.requestType == 'cancel' ) {
            getListService()
  
          }
          if(args.requestType == 'save'){
            let data = {
              ShopID:args.data.ShopID,
              ShopName:args.data.ShopName,
              LocalCurrencyOpening:args.data.LocalCurrencyOpening,
              SerialNo:args.data.SerialNo
            }
            console.log(data)
          if(args.action == 'add'){
            ShopService.insert(data).then(async (res)=>{
              await getListService()
              // let AddData = {
              //   UnitOfMeasurementID:args.data.UnitOfMeasurementID,
              //   UnitOfMeasurement:args.data.UnitOfMeasurement,
              // }
              // AuditTableInput.auditAdd(`UnitOfMeasurement`,`UnitOfMeasurement`,`UnitOfMeasurementID`,AddData)
            })
          }
          if(args.action == 'edit'){
            ShopService.update(data).then((res)=>{
              getListService()
  
              // let EditData = {
              //     UnitOfMeasurementID:args.data.UnitOfMeasurementID,
              //     UnitOfMeasurement:args.data.UnitOfMeasurement
              // }
              // let totalColumns = Object.keys(EditData);
              //             console.log(totalColumns)
              //             AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`UnitOfMeasurement`,args.data.MainUnitOfMeasurementID)
            })
          }
          }
          
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = true
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Shop${typeMode} 
        let ListSecurity='ShopTransferList'
        let AddSecurity='ShopTransferAdd'
        let EditSecurity='ShopTransferEdit'
        let DeleteSecurity='ShopTransferDelete'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions ='All';

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Shop' ,
                    TableID:'ShopID',
                   // Optional if Delete is Soft // TableSecurity:'ShopDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Shop' ,TableID:'ShopID', Optional // TableSecurity:'ShopDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <IrtizaDynamicInputList
        Id='Shop'
        ListTitle='Shop - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> ShopService.getShopForList()
                        }]}
        DefaultSortedColumnName={'ShopID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<ShopAdd  />
                // Dialog:[
                //   {
                //     Title:'Invoice Evaluation',
                //     Inputs:[
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'ShopID',value:'ShopName'},type:'dropdown',dataSource:{type:'Route',Route:'ShopName'},defaultValues:null},
                //       {field:'ExchangeRate'	,type:'float',defaultValues:null},
                //       {field:'HawalaCommissionPercent'	,type:'float',defaultValues:null},
                //       {field:{id:'ShopIDHawala',value:'ShopNameHawala	'},type:'dropdown',dataSource:{type:'Route',Route:'ShopName'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null}
                //     ]
                //   }
                // ]

            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            IsDialog={isDialog}
            {...props}
            ></IrtizaDynamicInputList>
        
            );
}



export default ShopInput;
